<template>
  <div id="reports-page" class="reporting">
    <ReportTable :columns="columns"
                 :items="items"
                 :custom-formatted-columns="['display_name']"
                 item-name="customer"
                 :show-form-toggle="false"
                 new-button-title="New Customer"
                 new-button-url="/dashboard#/customers/new">
      <template v-slot:cell(display_name)="data">
        <div class="column-text-wrapper">
          <router-link :to="{ path: `customers/${data.data.item.id}` }">
            {{ data.data.value }}
          </router-link>
        </div>
      </template>
      <template v-slot:cell(link)="data">
        <div class="data-table-body-row-link-wrapper">
          <router-link :to="{ path: `customers/${data.data.item.id}` }" class="data-table-body-row-link-wrapper-icon">
            <i class="demo-icon icon-chevron-right icon-chevron-right" />
          </router-link>
        </div>
      </template>
    </ReportTable>
  </div>
</template>

<script>
import store from "./CustomerStore";
import CustomerMixin from "./CustomerMixin";
import ReportTable from "../../../shared/components/UI/Report/Table.vue";

const responseStore = {
  response: null
};

const fetchResource = async (to, _from, next) => {
  responseStore.response = await store.fetchAll(to.params);

  next();
};

export default {
  name: "CustomerIndex",

  title () {
    return `Customers - ${Dashboard.currentTenant.name}`;
  },

  components: {
    ReportTable
  },

  mixins: [CustomerMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store,
      columns: [
        {
          key: "display_name",
          label: "Display Name",
          filterLabel: "Display Name",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "first_name",
          label: "First Name",
          filterLabel: "First Name",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "last_name",
          label: "Last Name",
          filterLabel: "Last Name",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "company_name",
          label: "Company Name",
          filterLabel: "Company Name",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "email",
          label: "Email",
          filterLabel: "Email",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "mobile_number",
          label: "Mobile Number",
          filterLabel: "Mobile Number",
          sortable: true,
          searchable: true,
          visible: true,
          visibleSmallScreen: true
        },
        {
          key: "link",
          label: "",
          filterLabel: "",
          visible: true,
          visibleSmallScreen: true,
          class: "data-table-body-row-link",
          thClass: "data-table-header-ghost"
        }
      ]
    };
  },

  computed: {
    items () {
      return this.collection.map(e => ({ ...e, link: `dashboard#/customers/${e.id}` }));
    }
  }
};
</script>
